import { useEffect } from "react";
import useInactivity from "../hooks/useInactivity";
import { WysiwygDisplay } from "./WysiwygDisplay";

export const CourseBasic = ({ lesson }) => {
    const { isInactive, isTabInactive } = useInactivity();

    useEffect(() => {
        if (isInactive || isTabInactive) {
            console.log("User is inactive");
        }
    }, [isInactive, isTabInactive]);

    return (
        <div>
            <h2>{lesson?.title}</h2>
            <WysiwygDisplay data={lesson?.description} />
        </div>
    );
};
